import * as moment from 'moment'
import { Moment } from 'moment'
import * as React from 'react'
import { IHolidayItem } from '../../../../types/index'
import TrashIcon from '../../../icons/ui/Trash'
import ContextMenu from '../../../ui/ContextMenu'
import WorkingTime from '../WorkingTime'
import { Datepicker } from '@mobiscroll/react'

interface IServiceHolidayItemProps {
  holidayItem: IHolidayItem
  onRemoveClick: (id: string) => void
  onSetFrom: (holidayItemId: string, from: string) => void
  onSetUntil: (holidayItemId: string, until: string) => void
  onSetDate: (holidayItemId: string, date: Date) => void
}

const ServiceHolidayItem = (props: IServiceHolidayItemProps) => {
  const {
    holidayItem,
    holidayItem: { date, from, id, until },
    onSetDate,
    onSetFrom,
    onSetUntil,
    onRemoveClick
  } = props

  const handleDateClick = (value: Date) => {
    const date = moment(value)
      .utcOffset(0, true)
      .format()
    onSetDate(id, moment(date).toDate())
  }

  const handleTimeSet = (type: string, time: string) => {
    type === 'from' ? onSetFrom(id, time) : onSetUntil(id, time)
  }

  const handleRemoveClick = () => {
    onRemoveClick(id)
  }

  return (
    <div className='mt3'>
      {/*Labels*/}
      <div className='flex flex-row' style={{ columnGap: '15px' }}>
        <div>
          <div className='h5 font-dark-grey'>Date of Exception</div>
          <Datepicker
            controls={['calendar']}
            dateFormat='YYYY/MM/DD'
            inputProps={{
              className: 'rounded p1 h4 mt02 border-light-grey4'
            }}
            value={date}
            onChange={({ value }) => handleDateClick(value)}
          />
        </div>
        <div>
          <div className='h5 font-dark-grey'>From - Until</div>
          <WorkingTime from={from} type='long' until={until} onTimeSet={handleTimeSet} />
        </div>
        <div className='mt1 pt2 self-center'>
          <ContextMenu>
            <div className='MenuItem flex items-center cursor--pointer p1' onClick={handleRemoveClick}>
              <TrashIcon className='icon--22x22 svg-stroke-grey3 mr1' />
              <span className='font-dark-grey'>Remove</span>
            </div>
          </ContextMenu>
        </div>
      </div>
    </div>
  )
}

export default ServiceHolidayItem



// WEBPACK FOOTER //
// ./src/components/services/edit/holidays/ServiceHolidayItem.tsx